import {area} from '../path/shapes';
import markMultiItemPath from './markMultiItemPath';

export default markMultiItemPath('area', area);



//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/marks/area.js
// module id = 1475
// module chunks = 0